module.exports = {
  name: "Holodex",
  pitchPhrase: "People and Groups",
  pitchSentence: "Holodex empowers you to discover people, understand relationships, and organize roles as they emerge in your groups.",
  description: "Holodex is a web-based directory to search, visualize, and manage groups of people. The system is built around you, so everyone can come together.",
  valueProps: [],
  callToAction: {
    text: "Request an invite",
    url: ""
  }
}
